import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';

@Component({
  selector: 'wfm-tabs-item',
  templateUrl: './tabs-item.component.html',
  styleUrls: ['./tabs-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TabsItemComponent {
  id: any;

  private $selected: boolean;
  set selected(v: boolean) {
    this.$selected = v;
    this.cd.detectChanges();
  }

  get selected(): boolean {
    return this.$selected;
  }

  @Input() disabled: boolean;

  @Input() label: string;

  @Input() maxWidth: string;

  constructor(private cd: ChangeDetectorRef) {}
}
